<!--==============================
=            WISGETS2            =
===============================-->
<template>
  <!-- page blank -->
  <v-container>
    <v-row no-gutters>
      <base-header>
        <div slot="page-header">Ecommerce Dashboard</div>
      </base-header>
    </v-row>
    <v-row no-gutters>
      <v-col cols="12" sm="12" md="12" d-flex>
        <analytic-sparkline></analytic-sparkline>
      </v-col>
    </v-row>
    <v-row no-gutters>
      <v-col cols="12" sm="12" md="12">
        <base-card class="pa-2">
          <div slot="card-header">Sessions Device</div>
          <div slot="card-body">
            <chart-areaapex></chart-areaapex>
          </div>
        </base-card>
      </v-col>
    </v-row>

    <v-row no-gutters>
      <v-col cols="12" sm="12" md="6" d-flex>
        <base-card class="pa-2">
          <div slot="card-header">Analytics</div>
          <div slot="card-body">
            <table-planner></table-planner>
          </div>
        </base-card>
      </v-col>
      <v-col cols="12" sm="12" md="6" d-flex>
        <base-card class="pa-2">
          <div slot="card-header">Reactive</div>
          <div slot="card-body">
            <table-plain></table-plain>
          </div>
        </base-card>
      </v-col>
    </v-row>
    <v-row no-gutters>
      <v-col cols="12" sm="12" md="12">
        <base-card class="pa-2">
          <div slot="card-header">Customers Growth</div>
          <div slot="card-body">
            <table-apex></table-apex>
          </div>
        </base-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import BaseCard from "../../layout/Base/BaseCard.vue";
import BaseHeader from "../../layout/Base/BaseHeader.vue";
import ListFriends from "../../components/Widgets/List/ListFriends.vue";
import ListFavorite from "../../components/Widgets/List/ListFavorite.vue";
import ListMessages from "../../components/Widgets/List/ListMessages.vue";
import ListNotification from "../../components/Widgets/List/ListFriends.vue";
import ListLove from "../../components/Widgets/List/ListLove.vue";
import TableOrder from "../../components/Widgets/Table/TableOrder.vue";
import TablePlanner from "../../components/Widgets/Table/TablePlanner.vue";
import TablePlain from "../../components/Widgets/Table/TablePlain.vue";
import TableBrowser from "../../components/Widgets/Table/TableBrowser.vue";
import ChartAreaapex from "../../components/Widgets/Charts/ChartAreaapex.vue";
import ChartAreaapex2 from "../../components/Widgets/Charts/ChartAreaapex2.vue";
import TableApex from "../../components/Widgets/Table/TableApex.vue";
import ChartLineapex from "../../components/Widgets/Charts/ChartLineapex.vue";
import ChartBarecharts from "../../components/Widgets/Charts/ChartBarecharts.vue";
import ChartBarapex from "../../components/Widgets/Charts/ChartBarapex.vue";
import ChartMixapex from "../../components/Widgets/Charts/ChartMixapex.vue";
import PieCard from "../../components/Widgets/Charts/PieCard";
import ChartPieapex from "../../components/Widgets/Charts/ChartPieapex.vue";
import ChartCanvas from "../../components/Widgets/Charts/ChartCanvas.vue";
import AnalyticApexcharts from "../../components/Widgets/Analytic/AnalyticApexcharts.vue";
import AnalyticSparkline from "../../components/Widgets/Analytic/AnalyticSparkline.vue";
import AnalyticInfo from "../../components/Widgets/Analytic/AnalyticInfo.vue";
import AnalyticMix from "../../components/Widgets/Analytic/AnalyticMix.vue";
import AnalyticProgress from "../../components/Widgets/Analytic/AnalyticProgress.vue";

export default {
  components: {
    BaseCard,
    BaseHeader,
    ListFriends,
    ListFavorite,
    ListMessages,
    ListNotification,
    ListLove,
    TableOrder,
    TablePlanner,
    ChartAreaapex,
    ChartLineapex,
    ChartMixapex,
    ChartPieapex,
    AnalyticApexcharts,
    AnalyticSparkline,
    AnalyticInfo,
    AnalyticMix,
    AnalyticProgress,
    ChartBarapex,
    TablePlain,
    PieCard,
    TableBrowser,
    ChartBarecharts,
    ChartAreaapex2,
    ChartCanvas,
    TableApex
  }
};
</script>
<!--====  End of WISGETS2  ====-->